import { createContext, useContext, useTransition } from "react";

type NavigationTransitionStarter = ReturnType<typeof useTransition>[1];

export const NavigationTransitionContext =
  createContext<NavigationTransitionStarter | null>(null);

export const useNavigationTransition = () => {
  const startNavigationTransition = useContext(NavigationTransitionContext);

  if (!startNavigationTransition) {
    throw new Error(
      "useNavigationTransition must be used within NavigationPendingOutlet",
    );
  }

  return startNavigationTransition;
};
